import React from 'react';
import { useLayoutState } from 'components/shared/Layout';

function fract(n) {
  return Number(String(n).split('.')[1] || 0);
}

const DisplayMoney = (num) => {
  const { layoutState } = useLayoutState();
  const formattedPrice = new Intl.NumberFormat(
    ((layoutState?.current_language) && layoutState.current_language.code),
    {
      style: 'currency',
      currency: layoutState.current_currency.code,
      minimumFractionDigits: fract(num) > 0 ? 2 : 0,
    },
  ).format(num);
  return formattedPrice;
};

export default DisplayMoney;
